import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useApi } from "@/lib/api";

export const FaqList = ({ category = "home", testId = "faq-accordion" }) => {
  const { data } = useApi(`/faqs?category=${category}`);
  return (
    <Accordion type="single" collapsible className="space-y-3" data-testid={testId}>
      {(data || []).map((f, i) => (
        <AccordionItem key={f.id} value={f.id} className="card-base border px-5 sm:px-6">
          <AccordionTrigger className="py-5 text-left font-heading text-base font-semibold text-navy hover:no-underline" data-testid={`${testId}-item-${i}`}>{f.question}</AccordionTrigger>
          <AccordionContent className="pb-5 text-sm leading-relaxed text-body">{f.answer}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
